<script setup>
``;
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
<template>
  <div class="section-container">
    <div class="relative z-10 flex flex-col justify-center items-start w-full text-left h-full">
      <!-- Title -->
      <h2
        class="text-4xl md:text-5xl"
      >{{ $t('Op zoek naar vaste medewerkers?Plaats een vacature!') }}</h2>
      <div class="mt-5 text-lg md:text-xl">{{ $t('Direct de app downloaden') }}</div>
      <div class="flex flex-col sm:flex-row justify-center items-center gap-6 mt-2">
        <!-- Google Play -->
        <a href="#" class="bg-green-100 px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition">
          <img src="@/../img/home/google-icon.png" alt="Get it on Google Play" class="h-12" />
        </a>
        <!-- App Store -->
        <a href="#" class="bg-green-100 px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition">
          <img src="@/../img/home/app-store-icon.png" alt="Download on the App Store" class="h-12" />
        </a>
      </div>
    </div>
  </div>
</template>
